<script setup>
import { computed, ref, useAttrs, useSlots } from 'vue'

// 组件导入
const components = {
  single: () => import('./question/single'), // 单选
  multiple: () => import('./question/multiple'), // 多选
  blank_fill: () => import('./question/blank_fill'), // 填空
  sort: () => import('./question/sort'), // 排序
  scale: () => import('./question/scale'), // 量表
  text_fill: () => import('./question/text_fill'), // 简答
  rich_text: () => import('./question/rich_text.vue') // 富文本
}

const props = defineProps({
  list: {
    type: [Array, Object],
    default: () => []
  },
  isShowCorrect: {
    type: Boolean,
    default: () => false
  },
  themeName: {
    type: String,
    // 主题名称 default | case-practice
    default: () => 'default'
  }
})
const attrs = useAttrs()
const slots = useSlots()

const itemRefs = ref({})
const questionList = computed(() => {
  let arr = props.list

  if (Object.prototype.toString.call(props.list) === '[object Object]') {
    arr = [props.list]
  }
  arr = arr.sort(compare('examIndex'))
  arr = addTitleNumber(arr)

  return arr
})

function setItemRef(el, key) {
  if (key) {
    itemRefs.value[key] = el
  }
}

function compare(p) {
  return (m, n) => {
    const a = m[p]
    const b = n[p]
    return a - b
  }
}
function addTitleNumber(arr) {
  const indexArr = arr
    .filter(item => item.examTypeEnum)
    .map((item, index) => {
      if (!item.titleIndex) {
        item.titleIndex = index + 1
      }
      item.answers = item.answers || []
      return item
    })
  return arr.map(item => {
    indexArr.forEach(indexItem => {
      if (item.examId === indexItem.examId) {
        item.titleIndex = item.titleIndex || indexItem.titleIndex
      }
    })
    return item
  })
}

function reset() {
  questionList.value?.map(item => {
    item.submitAnswer = null
  })
}

function onSubmit() {
  return new Promise((resolve, reject) => {
    const arr = questionList.value?.map(item => {
      const key = item.examId || item.examIndex
      return itemRefs.value[key]?.onSubmit()
    })
    Promise.all(arr)
      .then(res => resolve(res))
      .catch(error => reject(error))
  })
}

defineExpose({
  onSubmit,
  reset,
  addTitleNumber
})

</script>

<template>
  <div class="answer-container">
    <component
      :is="components[listItem.examTypeEnum] || components['rich_text']"
      v-for="listItem in questionList"
      :ref="(el) => setItemRef(el, listItem.examId || listItem.examIndex)"
      :key="listItem.examId"
      :theme-name="themeName"
      v-bind="{ ...attrs, ...listItem.customBinds }"
      :item="listItem"
      :is-show-correct="isShowCorrect"
      v-on="$listeners"
    >
      <template v-for="(_, name) in slots" #[name]="slotData">
        <slot :name="name" v-bind="slotData" />
      </template>
    </component>
  </div>
</template>

<style scoped lang="scss">
@import './common/styles/default.scss';
@import './common/styles/case-practice.scss';
// scss
.answer-container {
  box-sizing: border-box;
  :deep(.exam-body-box) {
    margin-bottom: 10px;
    font-size: $font-size-small;
    .exam-answer-box {
      padding: 10px;
    }
    .exam-title {
      padding: 14px 14px 0 14px;
      font-weight: bold;
      color: $text-color-main;
    }
    .exam-title-image {
      height: 18px;
      width: 18px;
      flex-shrink: 0;
      vertical-align: text-bottom;
    }
  }
}
</style>
